<template>
  <div class="outer-div" :style="style">
    <div ref="innerDiv" style="position:absolute;width:100%;height:100%;overflow:hidden;display:flex;justify-content:center;align-items:center">
        <div class="logo-div" :style="logoStyle" @click="click">
          <canvas ref="canvasOuter" class="outerRing" style="position:absolute;left:0;top:0;width:200px;height:200px" width="200" height="200">
          </canvas>
          <canvas ref="canvasInner" class="middleRing" style="position:absolute;left:0;top:0;width:200px;height:200px" width="200" height="200">
          </canvas>
    
        </div>
        <div ref="centerText" class="centerText" :style="textStyle">Z</div>
    </div>
  </div>
</template>

<script>
import * as $Z from '../../../lib/zentiant.js';

export default {
  name: "Logo",
  components:{},
  data() {
    return {
        appSettings:{
            defaultWidth:400,
            defaultHeight:400,
        },
        propertyDefs:{
            background: {
                type: "color",
                description: "Logo background color",
            },
            logoScale: {
                type: Number,
                description: "Scale factor for logo",
                options: {min:0,max:5,step:0.1},
            }
        },
        message: 'Hello World',
        width: 120,
        scaleFactor:1,
        lastWidth:-1,
        lastHeight:-1,
        resizeTimer: null,
    };
  },
  computed: {
    style:function(){
      return "background:"+this.background+";box-shadow:" + this.shadow
    },
    logoStyle:function(){
      return "transform:scale(" + this.logoScale + ")"
    },
    textStyle:function(){
      return "color:" + this.textColor + ";font-size:" + (26 * this.scaleFactor) + "px;transform:scale(" + this.logoScale + ") translateZ(10px)"
    }
  },
  props:{
      background:{
        type:String,
        default:"white"
      },
      logoScale:{
        type:Number,
        default:.8
      },
      outerRingColor:{
        type:String,
        default:"rgb(31,42,89)"
      },
      middleRingColor:{
        type:String,
        default:"rgb(258,157,49)"
      },
      innerRingColor:{
        type:String,
        default:"rgb(31,42,89)"
      },
      textColor:{
        type:String,
        default:"white"
      },
      shadow:{
        type:String,
        default:"none"
      },
      eventHandlers:{
        type:Object,
        default:function(){
          return{
            load:function(t,e){
            },
            click:function(t,e){
            }
          }
        },
        description:"Custom handlers for app events"
      }
    },
    watch: {
        outerRingColor: function() {
            this.drawLogo()
        },
        middleRingColor: function() {
            this.drawLogo()
        },
        innerRingColor: function() {
            this.drawLogo()
        }


    },
    methods:{
      resize:function(){
        this.drawLogo()
      },
      checkResize: function(){
        let self=this
        clearTimeout(self.resizeTimer)
        self.resizeTimer=setTimeout(self.checkResize,50)  
        try{
            let newWidth=self.$refs.innerDiv.offsetWidth
            let newHeight=self.$refs.innerDiv.offsetHeight
            if(self.lastWidth!=newWidth || self.lastHeight!=newHeight){
                self.lastWidth=newWidth
                self.lastHeight=newHeight
                self.resize()
            }
        }catch(err){}
      },
      click:function(ev){
        this.$emit("click",ev);  
      },
      drawLogo:function(){
        let width=this.$refs.innerDiv.offsetWidth
        let height=this.$refs.innerDiv.offsetHeight
        
        
        let dpr=2 //higher number = better quality when scaling logo
        this.scaleFactor=width/200 * dpr

        console.log(width)
        this.$refs.canvasOuter.width=width * dpr
        this.$refs.canvasOuter.height=height * dpr 
        this.$refs.canvasInner.width=width * dpr
        this.$refs.canvasInner.height=height * dpr
        
        this.$refs.canvasOuter.style.width=width + "px"
        this.$refs.canvasOuter.style.height=height + "px"
        this.$refs.canvasInner.style.width=width + "px"
        this.$refs.canvasInner.style.height=height + "px"
        
      
        this.$refs.canvasOuter.getContext("2d").clearRect(0,0,2000,2000);
        this.$refs.canvasInner.getContext("2d").clearRect(0,0,2000,2000);
        this.drawArc(this.$refs.canvasOuter,90,160,359.9,this.outerRingColor);
        this.drawArc(this.$refs.canvasOuter,90,30,120,this.outerRingColor);
        this.drawArc(this.$refs.canvasInner,65,-45,280,this.middleRingColor);
        this.drawArc(this.$refs.canvasInner,39,0,360,this.innerRingColor,true)
      },
      drawArc:function(c, radius, startAngle, endAngle, fillColor, fill){
        if(!fillColor) fillColor="black";
        var ctx=c.getContext("2d");
        console.log("this.scaleFactor",this.scaleFactor)
        
        var lineWidth=17*this.scaleFactor
        radius=radius*this.scaleFactor
  			if(fill) lineWidth=0
  			ctx.lineWidth=lineWidth
  			ctx.strokeStyle=fillColor
  			ctx.beginPath();
  			ctx.arc(c.width/2, c.height/2, radius-lineWidth/2, startAngle*Math.PI/180, endAngle*Math.PI/180);
  			if(fill){
  				ctx.fillStyle=fillColor
  				ctx.fill()
  			}else{
  			    ctx.stroke();
  			}
      }
    },
    beforeCreate(){
    },
    mounted(){
      $Z.init(this);
      var self=this;
      window.addEventListener("resize",function(){
        //console.log("Window resize");
        self.resize()
      });

      self.checkResize()
      self.$nextTick(()=>{
        self.drawLogo()
      })

      //alert($Z.sayHello())
    }

};
</script>

<style scoped>

.outer-div {
    position:relative;
    overflow:hidden;
    width:100%;
    height:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select:none;
  }

  .logo-div {
    width:100%;
    height:100%;
    position:absolute;
    overflow:hidden;
  }

  .outerRing {
    -webkit-animation: spinOuter 1.2s linear infinite; /* Safari */
    animation: spinOuter 12s linear infinite;
  }

   /* Safari */
   @-webkit-keyframes spinOuter {
     0% { -webkit-transform: rotate(0deg);}
     100% { -webkit-transform: rotate(-360deg);}
    }

    @keyframes spinOuter {
      0% { transform: rotate(0deg);}
      100% { transform: rotate(-360deg);}
    }

    .middleRing {
      -webkit-animation: spin 1.2s linear infinite; /* Safari */
      animation: spin 12s linear infinite;
    }

    .centerText {
      left:0;top:0;width:200px;height:200px;z-index:100;display:flex;align-items:center;justify-content:center;font-family:Roboto;color:white
    }

    /* Safari */
    @-webkit-keyframes spin {
      0% {   -webkit-transform: rotate(0deg); }
      100% { -webkit-transform: rotate(360deg);}
    }

    @keyframes spin {
      0% { transform: rotate(0deg);}
      100% { transform: rotate(360deg);}
    }


</style>